// 텍스트 유틸리티: 스레드 첫 문장 추출 (표준)
// 기준: CollectionThreadContent.js 의 getFirstSentence 구현

/**
 * 주어진 텍스트에서 첫 문장을 추출한다.
 * - 개행(\n) 또는 마침표(.) 기준 분리
 * - 특수문자 '�' 제거
 * - 양끝 공백 제거
 * @param {string} text
 * @returns {string}
 */
export function getFirstSentence(text) {
  if (!text || typeof text !== 'string') return '';
  const sentences = text.split(/[\n.]/);
  return (sentences[0] || '').replace(/�/g, '').trim();
}

/**
 * 첫 문장을 제외한 본문 텍스트 반환
 */
export function getBodyText(text) {
  if (!text || typeof text !== 'string') return '';
  const first = getFirstSentence(text);
  let remaining = text.replace(first, '').trim();
  if (remaining.startsWith('.') || remaining.startsWith('\n')) {
    remaining = remaining.substring(1).trim();
  }
  return remaining.replace(/�/g, '');
}

/**
 * Threads API text_attachment 정규화: 문자열/배열/객체 → 문자열
 */
export function normalizeTextAttachment(att) {
  if (!att) return '';
  if (typeof att === 'string') return att;
  if (Array.isArray(att)) return att.map(normalizeTextAttachment).filter(Boolean).join('\n');
  if (typeof att === 'object') {
    return (
      att.plaintext || att.plain_text || att.text || (typeof att.content === 'string' ? att.content : '') || ''
    );
  }
  return String(att);
}

/**
 * 카드 미리보기용 텍스트 선택 규칙
 * - 본문(제목 제외)이 있으면 본문
 * - 없으면 text_attachment
 * - 둘 다 없으면 제목 → 원문 순서
 */
export function getPreviewTextFromThread(thread, maxLen = 140) {
  const raw = thread?.text || '';
  const title = getFirstSentence(raw);
  const body = getBodyText(raw).trim();
  const ta = normalizeTextAttachment(thread?.text_attachment).trim();
  const src = body || ta || title || raw;
  const sliced = src.length > maxLen ? src.slice(0, maxLen).trim() + '…' : src;
  return sliced;
}
